// extracted by mini-css-extract-plugin
export var black = "eyebrow-module--black--be87e";
export var eyebrow = "eyebrow-module--eyebrow--6622c";
export var white = "eyebrow-module--white--45bf3";